import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";

const EMPTY = { name: "", type: "PDF", size: "120 KB" };

export default function DocumentUploadDialog({ open, onOpenChange, onSubmit }) {
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    if (open) setForm(EMPTY);
  }, [open]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const valid = form.name.trim().length > 0;

  const submit = (e) => {
    e.preventDefault();
    if (!valid) return;
    const inferred =
      form.name.toLowerCase().endsWith(".pdf") ? "PDF" :
      form.name.toLowerCase().endsWith(".docx") ? "DOCX" :
      form.name.toLowerCase().endsWith(".png") || form.name.toLowerCase().endsWith(".jpg") ? "IMG" :
      form.type;
    onSubmit({ ...form, type: inferred });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="document-upload-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Upload Document</DialogTitle>
          <DialogDescription>
            Demo upload — file name is added to the list (no real file stored).
          </DialogDescription>
        </DialogHeader>

        <div className="mt-2 rounded-xl border-2 border-dashed border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/50 dark:bg-slate-900/50 p-6 text-center">
          <div className="mx-auto h-10 w-10 rounded-lg bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 flex items-center justify-center">
            <Upload className="h-4 w-4 text-slate-500 dark:text-slate-400" />
          </div>
          <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">Drop your file here or enter a name below.</p>
        </div>

        <form onSubmit={submit} className="space-y-4 pt-2">
          <div className="space-y-2">
            <Label htmlFor="d-name" className="text-xs uppercase tracking-wider text-slate-700 dark:text-slate-300 font-medium">File name</Label>
            <Input id="d-name" data-testid="document-upload-name" value={form.name} onChange={set("name")} placeholder="Invoice-2026-02.pdf" className="h-10 rounded-lg" required />
          </div>
          <div className="space-y-2">
            <Label htmlFor="d-size" className="text-xs uppercase tracking-wider text-slate-700 dark:text-slate-300 font-medium">Size</Label>
            <Input id="d-size" data-testid="document-upload-size" value={form.size} onChange={set("size")} placeholder="120 KB" className="h-10 rounded-lg" />
          </div>
          <DialogFooter className="pt-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="document-upload-cancel" className="rounded-lg">
              Cancel
            </Button>
            <Button type="submit" disabled={!valid} data-testid="document-upload-submit" className="bg-primary hover:bg-primary/90 rounded-lg">
              Upload
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
